import favicon from "./assets/brand-specific/gnss-fill.svg"
import SimpleRtkTextLogo from "./assets/brand-specific/SimpleRTK/SimpleRTK-textLogo-cropped.png"
import SimpleRtkLogo from "./assets/brand-specific/SimpleRTK/SimpleRTK-SLogo.png"
import logo from "./assets/brand-specific/gnss-fill.svg"

// TractorGPS
import TractorGpsTextLogoWhite from "./assets/brand-specific/TractorGPS/tractorGPS-textlogo-w.png"
import TractorGpsLogo from "./assets/brand-specific/TractorGPS/tractorGPS-logo.png"

// Machine Control Solutions
import McsTextLogo from "./assets/brand-specific/MCS/MCS-textLogo.png"
import McsLogo from "./assets/brand-specific/MCS/MCS-favicon.png"

// Van Der Sluis
import VanDerSluisTextLogoWhite from "./assets/brand-specific/VanDerSluis/VanDerSluis-textLogo-w.png"
import VanDerSluisLogo from "./assets/brand-specific/VanDerSluis/VanDerSluis-favicon.png"

// Villapark Fontein
import VillaparkFonteinTextLogoWhite from "./assets/brand-specific/VillaparkFontein/VillaparkFontein-textLogo-w.png"
import VillaparkFonteinLogo from "./assets/brand-specific/VillaparkFontein/VillaparkFontein-favicon.png"

// Avallo
import AvalloTextLogo from "./assets/brand-specific/Avallo/Avallo-textLogo.png"
import AvalloLogo from "./assets/brand-specific/Avallo/Avallo-favicon.png"

// ColleftiefEemland
import ColleftiefEemlandTextLogo from "./assets/brand-specific/CollectiefEemland/CollectiefEemland-textLogo.png"
import ColleftiefEemlandLogo from "./assets/brand-specific/CollectiefEemland/CollectiefEemland-favicon.png"

// Boskalis
import BoskalisTextLogoWhite from "./assets/brand-specific/Boskalis/Boskalis-textLogo-w.png"
import BoskalisLogo from "./assets/brand-specific/Boskalis/Boskalis-favicon.png"

// Apglos
import ApglosTextLogo from "./assets/brand-specific/Apglos/Apglos-textLogo.png"

// Van Baarsen
import VanBaarsenTextLogoWhite from "./assets/brand-specific/VanBaarsen/VanBaarsen-textLogo-w.png"
import VanBaarsenLogo from "./assets/brand-specific/VanBaarsen/VanBaarsen-favicon.png"

// EUGEO.io
import EugeoTextLogoWhite from "./assets/brand-specific/EUGEO/EUGEO-textLogo-w.png"
import EugeoLogo from "./assets/brand-specific/EUGEO/EUGEO-favicon.png"

// Greek TractorGPS
import GreekTractorGPSLogoWhite from "./assets/brand-specific/TractorGPS-Greek/tractorGPS-textlogo-w-gr.png"
import GreekTractorGPSLogo from "./assets/brand-specific/TractorGPS-Greek/tractorGPS-logo-gr.png"

// Onocoy
import OnocoyLogoWhite from "./assets/brand-specific/Onocoy/Onocoy-textLogo-w.png"
import OnocoyLogo from "./assets/brand-specific/Onocoy/Onocoy-favicon.png"

type Languages = "en" | "nl"

export type Branding = {
    brandName: string
    brandName2nd: string
    termsAndConditions?: string
    logoIcon?: string
    textLogo?: string
    textLogoOverride?: boolean // if true, the textLogo will be used instead of the logoIcon
    isRebranded: boolean
    language?: Languages
    staticLanguage?: boolean // if true, the language will not be changed when the user changes the language in the browser.
    showPromotionCTAs?: boolean
    darkModePrimaryColor: string // if not set, the default dark mode color will be used.
    favicon: string
    gtmContainerId?: string // Google Tag Manager Container ID, if not set, GTM will not be used.
    darkMapDefault?: boolean // if true, the dark map will be used by default. --- When dark/light mode is fully set up, this must be removed.
    stripeColors: {
        colorPrimary: string
        colorBackground: string
        buttonSecondaryColorBackground: string
        buttonSecondaryColorBorder: string
        buttonSecondaryColorText: string
        colorSecondaryText: string
        colorBorder: string
        colorDanger: string
        badgeNeutralColorBackground: string
        badgeNeutralColorBorder: string
        badgeNeutralColorText: string
        badgeSuccessColorBackground: string
        badgeSuccessColorBorder: string
        badgeSuccessColorText: string
        badgeWarningColorBackground: string
        badgeWarningColorBorder: string
        badgeWarningColorText: string
        badgeDangerColorBackground: string
        badgeDangerColorBorder: string
        badgeDangerColorText: string
        offsetBackgroundColor?: string // optional, only needed for dark mode.
        formBackgroundColor?: string // optional, only needed for dark mode.
        spacingUnit?: string
    }
}

export const defaultBranding: Branding = {
    brandName: "RTK FIX",
    brandName2nd: "Cloud",
    termsAndConditions: "https://rtkfix.com/terms-conditions/", // full link always, please.

    logoIcon: logo,
    favicon: favicon,

    isRebranded: false,
    showPromotionCTAs: true,

    darkModePrimaryColor: "#4afc2d",
    darkMapDefault: true,

    gtmContainerId: "GTM-TGWKNHQ",

    stripeColors: {
        colorPrimary: "#4afc2d",
        colorBackground: "#171717",
        buttonSecondaryColorBackground: "#171717",
        buttonSecondaryColorBorder: "#4afc2d",
        buttonSecondaryColorText: "#4afc2d",
        colorSecondaryText: "#C7C7C7",
        colorBorder: "#323232",
        colorDanger: "#DC2626",
        badgeNeutralColorBackground: "#9CA3AF",
        badgeNeutralColorBorder: "#9CA3AF",
        badgeNeutralColorText: "#333",
        badgeSuccessColorBackground: "#00E774",
        badgeSuccessColorBorder: "#093C02",
        badgeSuccessColorText: "#093C02",
        badgeWarningColorBackground: "#FFA500",
        badgeWarningColorBorder: "#523500",
        badgeWarningColorText: "#523500",
        badgeDangerColorBackground: "#DC2626",
        badgeDangerColorBorder: "#121212",
        badgeDangerColorText: "#121212",
        offsetBackgroundColor: "#171717",
        formBackgroundColor: "#121212",
        spacingUnit: "8px",
    }
}


const simpleRTK: Branding = {
    brandName: "SimpleRTK",
    brandName2nd: "",

    favicon: SimpleRtkLogo,

    textLogo: SimpleRtkTextLogo,
    textLogoOverride: true,
    isRebranded: true,

    showPromotionCTAs: false, // the iFrame promotion boxes in Sidebar

    darkModePrimaryColor: "#ff7901",

    stripeColors: {
        colorPrimary: "#ff7901",
        colorBackground: "#171717",
        buttonSecondaryColorBackground: "#171717",
        buttonSecondaryColorBorder: "#ff7901",
        buttonSecondaryColorText: "#ff7901",
        colorSecondaryText: "#C7C7C7",
        colorBorder: "#323232",
        colorDanger: "#DC2626",
        badgeNeutralColorBackground: "#9CA3AF",
        badgeNeutralColorBorder: "#9CA3AF",
        badgeNeutralColorText: "#333",
        badgeSuccessColorBackground: "#00E774",
        badgeSuccessColorBorder: "#093C02",
        badgeSuccessColorText: "#093C02",
        badgeWarningColorBackground: "#FFA500",
        badgeWarningColorBorder: "#523500",
        badgeWarningColorText: "#523500",
        badgeDangerColorBackground: "#DC2626",
        badgeDangerColorBorder: "#121212",
        badgeDangerColorText: "#121212",
        offsetBackgroundColor: "#171717",
        formBackgroundColor: "#121212",
        spacingUnit: "8px",
    }
}


const tractorGPS: Branding = {
    brandName: "TractorGPS.nl",
    brandName2nd: "",

    favicon: TractorGpsLogo,

    textLogo: TractorGpsTextLogoWhite,
    textLogoOverride: true,
    isRebranded: true,

    showPromotionCTAs: false, // the iFrame promotion boxes in Sidebar

    darkModePrimaryColor: "#1E90FF",

    stripeColors: {
        colorPrimary: "#1E90FF",
        colorBackground: "#171717",
        buttonSecondaryColorBackground: "#171717",
        buttonSecondaryColorBorder: "#ff7901",
        buttonSecondaryColorText: "#ff7901",
        colorSecondaryText: "#C7C7C7",
        colorBorder: "#323232",
        colorDanger: "#DC2626",
        badgeNeutralColorBackground: "#9CA3AF",
        badgeNeutralColorBorder: "#9CA3AF",
        badgeNeutralColorText: "#333",
        badgeSuccessColorBackground: "#00E774",
        badgeSuccessColorBorder: "#093C02",
        badgeSuccessColorText: "#093C02",
        badgeWarningColorBackground: "#FFA500",
        badgeWarningColorBorder: "#523500",
        badgeWarningColorText: "#523500",
        badgeDangerColorBackground: "#DC2626",
        badgeDangerColorBorder: "#121212",
        badgeDangerColorText: "#121212",
        offsetBackgroundColor: "#171717",
        formBackgroundColor: "#121212",
        spacingUnit: "8px",
    }
}

const machineControlSolutions: Branding = {
    brandName: "Machine Control Solutions",
    brandName2nd: "",

    favicon: McsLogo,

    textLogo: McsTextLogo,
    textLogoOverride: true,
    isRebranded: true,

    showPromotionCTAs: false, // the iFrame promotion boxes in Sidebar

    darkModePrimaryColor: "#e83c5d",

    stripeColors: {
        colorPrimary: "#e83c5d",
        colorBackground: "#171717",
        buttonSecondaryColorBackground: "#171717",
        buttonSecondaryColorBorder: "#4afc2d",
        buttonSecondaryColorText: "#4afc2d",
        colorSecondaryText: "#C7C7C7",
        colorBorder: "#323232",
        colorDanger: "#DC2626",
        badgeNeutralColorBackground: "#9CA3AF",
        badgeNeutralColorBorder: "#9CA3AF",
        badgeNeutralColorText: "#333",
        badgeSuccessColorBackground: "#00E774",
        badgeSuccessColorBorder: "#093C02",
        badgeSuccessColorText: "#093C02",
        badgeWarningColorBackground: "#FFA500",
        badgeWarningColorBorder: "#523500",
        badgeWarningColorText: "#523500",
        badgeDangerColorBackground: "#DC2626",
        badgeDangerColorBorder: "#121212",
        badgeDangerColorText: "#121212",
        offsetBackgroundColor: "#171717",
        formBackgroundColor: "#121212",
        spacingUnit: "8px",
    }
}

const vanDerSluis: Branding = {
    brandName: "Van Der Sluis",
    brandName2nd: "",

    favicon: VanDerSluisLogo,

    textLogo: VanDerSluisTextLogoWhite,
    textLogoOverride: true,
    isRebranded: true,

    showPromotionCTAs: false, // the iFrame promotion boxes in Sidebar

    darkModePrimaryColor: "#ff7a00",

    stripeColors: {
        colorPrimary: "#ff7a00",
        colorBackground: "#171717",
        buttonSecondaryColorBackground: "#171717",
        buttonSecondaryColorBorder: "#ff7901",
        buttonSecondaryColorText: "#ff7901",
        colorSecondaryText: "#C7C7C7",
        colorBorder: "#323232",
        colorDanger: "#DC2626",
        badgeNeutralColorBackground: "#9CA3AF",
        badgeNeutralColorBorder: "#9CA3AF",
        badgeNeutralColorText: "#333",
        badgeSuccessColorBackground: "#00E774",
        badgeSuccessColorBorder: "#093C02",
        badgeSuccessColorText: "#093C02",
        badgeWarningColorBackground: "#FFA500",
        badgeWarningColorBorder: "#523500",
        badgeWarningColorText: "#523500",
        badgeDangerColorBackground: "#DC2626",
        badgeDangerColorBorder: "#121212",
        badgeDangerColorText: "#121212",
        offsetBackgroundColor: "#171717",
        formBackgroundColor: "#121212",
        spacingUnit: "8px",
    }
}


const villaparkFontein: Branding = {
    brandName: "Villapark Fontein",
    brandName2nd: "",

    favicon: VillaparkFonteinLogo,

    textLogo: VillaparkFonteinTextLogoWhite,
    textLogoOverride: true,
    isRebranded: true,

    showPromotionCTAs: false, // the iFrame promotion boxes in Sidebar

    darkModePrimaryColor: "#ef7f5d",

    stripeColors: {
        colorPrimary: "#ef7f5d",
        colorBackground: "#171717",
        buttonSecondaryColorBackground: "#171717",
        buttonSecondaryColorBorder: "#ff7901",
        buttonSecondaryColorText: "#ff7901",
        colorSecondaryText: "#C7C7C7",
        colorBorder: "#323232",
        colorDanger: "#DC2626",
        badgeNeutralColorBackground: "#9CA3AF",
        badgeNeutralColorBorder: "#9CA3AF",
        badgeNeutralColorText: "#333",
        badgeSuccessColorBackground: "#00E774",
        badgeSuccessColorBorder: "#093C02",
        badgeSuccessColorText: "#093C02",
        badgeWarningColorBackground: "#FFA500",
        badgeWarningColorBorder: "#523500",
        badgeWarningColorText: "#523500",
        badgeDangerColorBackground: "#DC2626",
        badgeDangerColorBorder: "#121212",
        badgeDangerColorText: "#121212",
        offsetBackgroundColor: "#171717",
        formBackgroundColor: "#121212",
        spacingUnit: "8px",
    }
}


const avallo: Branding = {
    brandName: "Avallo",
    brandName2nd: "",

    favicon: AvalloLogo,

    textLogo: AvalloTextLogo,
    textLogoOverride: true,
    isRebranded: true,

    showPromotionCTAs: false, // the iFrame promotion boxes in Sidebar

    darkModePrimaryColor: "#98a968",

    stripeColors: {
        colorPrimary: "#98a968",
        colorBackground: "#171717",
        buttonSecondaryColorBackground: "#171717",
        buttonSecondaryColorBorder: "#ff7901",
        buttonSecondaryColorText: "#ff7901",
        colorSecondaryText: "#C7C7C7",
        colorBorder: "#323232",
        colorDanger: "#DC2626",
        badgeNeutralColorBackground: "#9CA3AF",
        badgeNeutralColorBorder: "#9CA3AF",
        badgeNeutralColorText: "#333",
        badgeSuccessColorBackground: "#00E774",
        badgeSuccessColorBorder: "#093C02",
        badgeSuccessColorText: "#093C02",
        badgeWarningColorBackground: "#FFA500",
        badgeWarningColorBorder: "#523500",
        badgeWarningColorText: "#523500",
        badgeDangerColorBackground: "#DC2626",
        badgeDangerColorBorder: "#121212",
        badgeDangerColorText: "#121212",
        offsetBackgroundColor: "#171717",
        formBackgroundColor: "#121212",
        spacingUnit: "8px",
    }
}

const collectiefEemland: Branding = {
    brandName: "Collectief Eemland",
    brandName2nd: "",

    favicon: ColleftiefEemlandLogo,

    textLogo: ColleftiefEemlandTextLogo,
    textLogoOverride: true,
    isRebranded: true,

    showPromotionCTAs: false, // the iFrame promotion boxes in Sidebar

    darkModePrimaryColor: "#9cde81",

    stripeColors: {
        colorPrimary: "#9cde81",
        colorBackground: "#171717",
        buttonSecondaryColorBackground: "#171717",
        buttonSecondaryColorBorder: "#ff7901",
        buttonSecondaryColorText: "#ff7901",
        colorSecondaryText: "#C7C7C7",
        colorBorder: "#323232",
        colorDanger: "#DC2626",
        badgeNeutralColorBackground: "#9CA3AF",
        badgeNeutralColorBorder: "#9CA3AF",
        badgeNeutralColorText: "#333",
        badgeSuccessColorBackground: "#00E774",
        badgeSuccessColorBorder: "#093C02",
        badgeSuccessColorText: "#093C02",
        badgeWarningColorBackground: "#FFA500",
        badgeWarningColorBorder: "#523500",
        badgeWarningColorText: "#523500",
        badgeDangerColorBackground: "#DC2626",
        badgeDangerColorBorder: "#121212",
        badgeDangerColorText: "#121212",
        offsetBackgroundColor: "#171717",
        formBackgroundColor: "#121212",
        spacingUnit: "8px",
    }
}

const boskalis: Branding = {
    brandName: "Boskalis",
    brandName2nd: "",

    favicon: BoskalisLogo,

    textLogo: BoskalisTextLogoWhite,
    textLogoOverride: true,
    isRebranded: true,

    showPromotionCTAs: false, // the iFrame promotion boxes in Sidebar

    darkModePrimaryColor: "#fff719",

    stripeColors: {
        colorPrimary: "#fff719",
        colorBackground: "#171717",
        buttonSecondaryColorBackground: "#171717",
        buttonSecondaryColorBorder: "#ff7901",
        buttonSecondaryColorText: "#ff7901",
        colorSecondaryText: "#C7C7C7",
        colorBorder: "#323232",
        colorDanger: "#DC2626",
        badgeNeutralColorBackground: "#9CA3AF",
        badgeNeutralColorBorder: "#9CA3AF",
        badgeNeutralColorText: "#333",
        badgeSuccessColorBackground: "#00E774",
        badgeSuccessColorBorder: "#093C02",
        badgeSuccessColorText: "#093C02",
        badgeWarningColorBackground: "#FFA500",
        badgeWarningColorBorder: "#523500",
        badgeWarningColorText: "#523500",
        badgeDangerColorBackground: "#DC2626",
        badgeDangerColorBorder: "#121212",
        badgeDangerColorText: "#121212",
        offsetBackgroundColor: "#171717",
        formBackgroundColor: "#121212",
        spacingUnit: "8px",
    }
}

const apglos: Branding = {
    brandName: "Apglos",
    brandName2nd: "",

    textLogo: ApglosTextLogo,
    textLogoOverride: true,
    isRebranded: true,

    favicon: logo,

    showPromotionCTAs: false, // the iFrame promotion boxes in Sidebar

    darkModePrimaryColor: "#f08515",

    stripeColors: {
        colorPrimary: "#f08515",
        colorBackground: "#171717",
        buttonSecondaryColorBackground: "#171717",
        buttonSecondaryColorBorder: "#ff7901",
        buttonSecondaryColorText: "#ff7901",
        colorSecondaryText: "#C7C7C7",
        colorBorder: "#323232",
        colorDanger: "#DC2626",
        badgeNeutralColorBackground: "#9CA3AF",
        badgeNeutralColorBorder: "#9CA3AF",
        badgeNeutralColorText: "#333",
        badgeSuccessColorBackground: "#00E774",
        badgeSuccessColorBorder: "#093C02",
        badgeSuccessColorText: "#093C02",
        badgeWarningColorBackground: "#FFA500",
        badgeWarningColorBorder: "#523500",
        badgeWarningColorText: "#523500",
        badgeDangerColorBackground: "#DC2626",
        badgeDangerColorBorder: "#121212",
        badgeDangerColorText: "#121212",
        offsetBackgroundColor: "#171717",
        formBackgroundColor: "#121212",
        spacingUnit: "8px",
    }
}

const vanBaarsen: Branding = {
    brandName: "Van Baarsen",
    brandName2nd: "",

    textLogo: VanBaarsenTextLogoWhite,
    textLogoOverride: true,
    isRebranded: true,

    favicon: VanBaarsenLogo,

    showPromotionCTAs: false, // the iFrame promotion boxes in Sidebar

    darkModePrimaryColor: "#fc0039",

    stripeColors: {
        colorPrimary: "#fc0039",
        colorBackground: "#171717",
        buttonSecondaryColorBackground: "#171717",
        buttonSecondaryColorBorder: "#ff7901",
        buttonSecondaryColorText: "#ff7901",
        colorSecondaryText: "#C7C7C7",
        colorBorder: "#323232",
        colorDanger: "#DC2626",
        badgeNeutralColorBackground: "#9CA3AF",
        badgeNeutralColorBorder: "#9CA3AF",
        badgeNeutralColorText: "#333",
        badgeSuccessColorBackground: "#00E774",
        badgeSuccessColorBorder: "#093C02",
        badgeSuccessColorText: "#093C02",
        badgeWarningColorBackground: "#FFA500",
        badgeWarningColorBorder: "#523500",
        badgeWarningColorText: "#523500",
        badgeDangerColorBackground: "#DC2626",
        badgeDangerColorBorder: "#121212",
        badgeDangerColorText: "#121212",
        offsetBackgroundColor: "#171717",
        formBackgroundColor: "#121212",
        spacingUnit: "8px",
    }
}

const eugeo: Branding = {
    brandName: "EUGEO",
    brandName2nd: "",

    textLogo: EugeoTextLogoWhite,
    textLogoOverride: true,
    isRebranded: true,
    darkMapDefault: true, // EUGEO.io uses a dark map by default.

    favicon: EugeoLogo,

    showPromotionCTAs: false, // the iFrame promotion boxes in Sidebar

    darkModePrimaryColor: "#17EF97",

    stripeColors: {
        colorPrimary: "#17EF97",
        colorBackground: "#171717",
        buttonSecondaryColorBackground: "#171717",
        buttonSecondaryColorBorder: "#ff7901",
        buttonSecondaryColorText: "#ff7901",
        colorSecondaryText: "#C7C7C7",
        colorBorder: "#323232",
        colorDanger: "#DC2626",
        badgeNeutralColorBackground: "#9CA3AF",
        badgeNeutralColorBorder: "#9CA3AF",
        badgeNeutralColorText: "#333",
        badgeSuccessColorBackground: "#00E774",
        badgeSuccessColorBorder: "#093C02",
        badgeSuccessColorText: "#093C02",
        badgeWarningColorBackground: "#FFA500",
        badgeWarningColorBorder: "#523500",
        badgeWarningColorText: "#523500",
        badgeDangerColorBackground: "#DC2626",
        badgeDangerColorBorder: "#121212",
        badgeDangerColorText: "#121212",
        offsetBackgroundColor: "#171717",
        formBackgroundColor: "#121212",
        spacingUnit: "8px",
    }
}

const greekTractorGPS: Branding = {
    brandName: "TractorGPS",
    brandName2nd: "",

    textLogo: GreekTractorGPSLogoWhite,
    textLogoOverride: true,
    isRebranded: true,
    darkMapDefault: true, // Greek TractorGPS uses a dark map by default.

    favicon: GreekTractorGPSLogo,

    showPromotionCTAs: false, // the iFrame promotion boxes in Sidebar

    darkModePrimaryColor: "#f5c612",

    stripeColors: {
        colorPrimary: "#f5c612",
        colorBackground: "#171717",
        buttonSecondaryColorBackground: "#171717",
        buttonSecondaryColorBorder: "#ff7901",
        buttonSecondaryColorText: "#ff7901",
        colorSecondaryText: "#C7C7C7",
        colorBorder: "#323232",
        colorDanger: "#DC2626",
        badgeNeutralColorBackground: "#9CA3AF",
        badgeNeutralColorBorder: "#9CA3AF",
        badgeNeutralColorText: "#333",
        badgeSuccessColorBackground: "#00E774",
        badgeSuccessColorBorder: "#093C02",
        badgeSuccessColorText: "#093C02",
        badgeWarningColorBackground: "#FFA500",
        badgeWarningColorBorder: "#523500",
        badgeWarningColorText: "#523500",
        badgeDangerColorBackground: "#DC2626",
        badgeDangerColorBorder: "#121212",
        badgeDangerColorText: "#121212",
        offsetBackgroundColor: "#171717",
        formBackgroundColor: "#121212",
        spacingUnit: "8px",
    }
}

const onocoy: Branding = {
    brandName: "Onocoy",
    brandName2nd: "",

    textLogo: OnocoyLogoWhite,
    textLogoOverride: true,
    isRebranded: true,
    darkMapDefault: true, // Onocoy uses a dark map by default.

    favicon: OnocoyLogo,

    showPromotionCTAs: false, // the iFrame promotion boxes in Sidebar

    darkModePrimaryColor: "#b4bd00",

    stripeColors: {
        colorPrimary: "#b4bd00",
        colorBackground: "#171717",
        buttonSecondaryColorBackground: "#171717",
        buttonSecondaryColorBorder: "#ff7901",
        buttonSecondaryColorText: "#ff7901",
        colorSecondaryText: "#C7C7C7",
        colorBorder: "#323232",
        colorDanger: "#DC2626",
        badgeNeutralColorBackground: "#9CA3AF",
        badgeNeutralColorBorder: "#9CA3AF",
        badgeNeutralColorText: "#333",
        badgeSuccessColorBackground: "#00E774",
        badgeSuccessColorBorder: "#093C02",
        badgeSuccessColorText: "#093C02",
        badgeWarningColorBackground: "#FFA500",
        badgeWarningColorBorder: "#523500",
        badgeWarningColorText: "#523500",
        badgeDangerColorBackground: "#DC2626",
        badgeDangerColorBorder: "#121212",
        badgeDangerColorText: "#121212",
        offsetBackgroundColor: "#171717",
        formBackgroundColor: "#121212",
        spacingUnit: "8px",
    }
}

const rebranded = process.env.REACT_APP_REBRANDED

const brandConfigs: Record<string, Branding> = {
    simpleRTK,
    tractorGPS,
    machineControlSolutions,
    vanDerSluis,
    villaparkFontein,
    avallo,
    collectiefEemland,
    boskalis,
    apglos,
    vanBaarsen,
    eugeo,
    greekTractorGPS,
    onocoy,
    defaultBranding
};
if (rebranded !== undefined && !Object.keys(brandConfigs).includes(rebranded)) {
    throw new Error(
        `[Branding Error] "${rebranded}" is not a valid brand key. Allowed values: ${Object.keys(brandConfigs).join(', ')}`
    );
}

export const branding: Branding =
    rebranded === undefined ? defaultBranding : brandConfigs[rebranded] || defaultBranding;
